import React from 'react';
import { Hash, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';
import { useT } from '@/lib/i18n';

const HashtagList = ({ hashtags = [] }) => {
  const { lang } = useT();
  const [copied, setCopied] = React.useState(false);
  const all = hashtags.map((h) => (h.startsWith('#') ? h : `#${h}`)).join(' ');
  const copyAll = async () => {
    try {
      await navigator.clipboard.writeText(all);
      setCopied(true);
      toast.success(lang === 'fr' ? 'Hashtags copiés' : 'Hashtags copied');
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Copy failed');
    }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-[#0a0a0a] p-4" data-testid="hashtag-list">
      <div className="flex items-center justify-between mb-3 gap-2">
        <div className="flex items-center gap-2">
          <Hash className="w-3.5 h-3.5 text-[#D4FF00]" />
          <span className="font-heading font-bold text-xs sm:text-sm uppercase tracking-wider">
            {lang === 'fr' ? 'Hashtags recommandés' : 'Recommended hashtags'}
          </span>
        </div>
        <button
          onClick={copyAll}
          className="text-xs text-zinc-400 hover:text-white flex items-center gap-1 px-2 py-1 rounded-md hover:bg-white/10 transition-colors"
          data-testid="copy-all-hashtags"
        >
          {copied ? <Check className="w-3 h-3 text-[#D4FF00]" /> : <Copy className="w-3 h-3" />}
          {lang === 'fr' ? 'Tout copier' : 'Copy all'}
        </button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {hashtags.length === 0 ? (
          <span className="text-zinc-600 text-sm italic">—</span>
        ) : hashtags.map((h, i) => (
          <span
            key={`${h}-${i}`}
            className="px-2.5 py-1 rounded-md bg-white/5 border border-white/10 text-zinc-300 text-xs font-mono hover:border-[#D4FF00]/40 hover:text-[#D4FF00] transition-colors cursor-default"
            data-testid={`hashtag-${i}`}
          >
            #{h.replace(/^#/, '')}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HashtagList;
